import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    header: {
      background: theme.gray50,
      borderRadius: "8px 8px 0 0",
      boxShadow: `0px 1px 0px ${theme.gray200}`,
      color: theme.gray800,
      padding: theme.spacing(6, 8),
    },
    container: {
      alignItems: "start",
      fontWeight: 500,
      flexWrap: "nowrap",
      gap: theme.spacing(12),
    },
    item: {
      background: theme.white00,
      border: `1px solid ${theme.gray200}`,
      borderRadius: 8,
      boxShadow: "0px 1px 1px rgba(154, 147, 147, 0.25)",
      display: "flex",
      flexDirection: "column",
    },
    itemContent: {
      boxShadow: `0px 1px 0px ${theme.gray100}`,
      display: "flex",
      gap: theme.spacing(10),
      justifyContent: "space-between",
      padding: theme.spacing(8, 12),
    },
    itemName: {
      color: theme.gray500,
      textWrap: "nowrap",
    },
    itemValue: {
      display: "flex",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      gap: theme.spacing(6),
      color: theme.gray800,
      maxHeight: "38px",
      textAlign: "right",
    },
  }),
);
